<template>
  <main class="m-2 flex min-h-0 flex-1 flex-row overflow-hidden bg-white rounded">
    <RegulationsNavigation />
    <section
      class="flex min-h-0 flex-2 flex-col overflow-hidden "
      aria-label="Selected regulation section"
    >
      <div v-if="regs.state.sectionLoading" class="flex flex-1 items-center justify-center p-6 text-sm text-gray-500">
        Loading regulation section...
      </div>
      <div v-else-if="regs.state.sectionError" class="flex flex-1 items-center justify-center p-6 text-sm text-red-700">
        {{ regs.state.sectionError }}
      </div>
      <SectionContent v-else-if="regs.state.currentSection" :section="regs.state.currentSection" />
      <div v-else class="flex flex-1 items-center justify-center p-6 text-sm text-gray-500">
        Select a regulation from the search results above.
      </div>
    </section>
  </main>
</template>

<script setup>
import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

import { useRegulationsState } from "../state.js";
import RegulationsNavigation from "../components/RegulationsNavigation.vue";
import SectionContent from "../components/SectionContent.vue";

const regs = useRegulationsState();
const route = useRoute();
const router = useRouter();
const searchedSelection = ref(null);

watch(
  () => [route.name, route.meta.partNumber, route.meta.latestAmendment, route.query.amendment, route.query.versionId],
  async ([routeName, partNumberParam, latestAmendmentParam, amendmentParam, versionIdParam]) => {
    const partNumber = String(partNumberParam);
    const latestAmendment = Number(latestAmendmentParam);
    const parsedAmendment = Number(amendmentParam);
    const amendment = Number.isInteger(parsedAmendment)
      && parsedAmendment >= 0
      && parsedAmendment <= latestAmendment
      ? parsedAmendment
      : latestAmendment;

    if (String(amendmentParam ?? "") !== String(amendment)) {
      await router.replace({
        name: routeName,
        query: { ...route.query, amendment: String(amendment) },
      });
      return;
    }

    const versionId = typeof versionIdParam === "string" && versionIdParam
      ? versionIdParam
      : null;
    const tasks = [];
    const selection = `${partNumber}:${amendment}`;

    if (regs.state.partNumber !== partNumber) regs.setPartNumber(partNumber);
    if (regs.state.amendmentNumber !== amendment) regs.setAmendment(amendment);
    if (searchedSelection.value !== selection) {
      searchedSelection.value = selection;
      tasks.push(regs.search());
    }

    if (versionId) tasks.push(regs.selectSection(versionId));
    else regs.clearSection();

    await Promise.all(tasks);
  },
  { immediate: true }
);
</script>
